const updateAllowedProps = [
  'fullPath',
  'timestamp',
]

class Asset {
  constructor(options = {}) {
    options = options || {}
    this.fullPath = options.fullPath
    this.timestamp = options.timestamp || (new Date()).valueOf()
  }

  // Class methods
  static init(options) {
    if (options instanceof Asset) {
      return options
    }
    const instance = new Asset(options)
    return instance.isValid ? instance : null
  }
  static initFromArray(arr) {
    if (Array.isArray(arr)) {
      return arr.map(this.init)
    }
    return []
  }
  static initOnlyValidFromArray(arr = []) {
    return this.initFromArray(arr).filter((i) => i)
  }

  // getters
  get isValid() {
    return !!this
  }
  updateAsset(update) {
    Object.keys(update).forEach((key) => {
      if (updateAllowedProps.includes(key)) {
        this[key] = update[key]
      }
    })
    return this
  }
}

export default {
  Asset
}
export {
  Asset
}
